<template>
  <v-dialog
    v-model="showForm"
    max-width="1500px"
    persistent
    content-class="overflow-hidden">
    <v-card>
      <div
        class="d-flex align-center justify-space-between primary muted-immutable--text fill-width px-6"
        style="height: 60px;">
        <div
          class="d-flex align-center">
          <span
            class="muted-immutable--text font-weight-bold ui-text-xl">
            {{ title }}
          </span>
        </div>
        <v-icon
          size="26"
          color="muted-immutable"
          @click="close">
          mdi-close
        </v-icon>
      </div>

      <section
        class="fill-width pa-6"
        style="max-height: 550px; overflow: auto;">
        <slot name="section"></slot>
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FormModal',
  data: () => ({ showForm: false }),
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  watch: {
    showForm(value, oldValue) {
      if (oldValue && !value) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    open() {
      this.showForm = true;
    },
    close() {
      this.showForm = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/shared/styles/historyModal/default.scss";
</style>
